import * as styles from "./SectionExternalSignPostCards.module.scss";

import { Button } from "../../../components/common";

import React from "react";

import ExternalSignPostCard from "../../../components/SignPostCards/ExternalSignPostCard/ExternalSignPostCard";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionExternalSignPostCardsProps {
	title?: string;
	items: DogsTrust.SignPostCardProps[];
	link?: { title: string; uri: string };
	isSuccessStories?: boolean;
}

export const SectionExternalSignPostCards: React.FC<
	SectionExternalSignPostCardsProps
> = ({ title, items, link }) => {
	items.sort((a, b) =>
		a.priority < b.priority ? -1 : a.priority < b.priority ? 1 : 0,
	);

	const allHaveImages = items.every((item) => item.imgSrc.length > 0);
	return (
		<WrappedSection sectionName="SectionExternalSignPostCards">
			<div className={styles.inner}>
				{title && (
					<div className={styles.titlecontainer}>
						<h2 className={styles.title}>{title}</h2>
					</div>
				)}
				<div className={styles.cardsection}>
					{items.map((item) => (
						<ExternalSignPostCard
							key={item.title}
							{...item}
							useStandardCard={allHaveImages}
						/>
					))}
				</div>
				{link?.uri && link.title && (
					<div className={styles.buttonwrapper}>
						<Button url={link?.uri} variant={"tertiary"} fullWidth={true}>
							{link?.title}
						</Button>
					</div>
				)}
			</div>
		</WrappedSection>
	);
};

export default SectionExternalSignPostCards;
